// extracted by mini-css-extract-plugin
export var container = "SlideOut-module--container--218e9";
export var scrim = "SlideOut-module--scrim--8637e";